import { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import FJAIVideoGeneratorConfig from '../../../../config/appConfig/FJAIVideoGeneratorConfig.js';
import classNames from 'classnames';
import FJImage from '../../../../common/components/FJImage/FJImage.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';

import styles from './FJAIVideoModelPreviewItem.module.less';

function FJAIVideoModelPreviewItem({ model, currentModel, onModelSelect }) {
    const videoRef = useRef(null);
    // REQUIREMENT: 默认自动播放，hover时播放声音，离开时静音
    const [isPlayingVideo, setIsPlayingVideo] = useState(false);

    const _onMouseOver = () => {
        setIsPlayingVideo(true);
    };

    const _onMouseLeave = () => {
        setIsPlayingVideo(false);
    };

    const handleClick = () => {
        onModelSelect?.(model);
    };

    // 构造item对象
    const item = useMemo(
        () => ({
            ...model,
            id: model.value,
            imageUrl: `${FJAIVideoGeneratorConfig.modelPreviewPath}${model.imageUrl}`,
            videoUrl: `${FJAIVideoGeneratorConfig.modelPreviewPath}${model.videoUrl}`,
        }),
        [model],
    );

    return (
        <div
            className={styles.model_item_wrapper}
            onMouseEnter={_onMouseOver}
            onMouseLeave={_onMouseLeave}
            data-model={item.value}
        >
            <FJHoverBoardGradation
                active={item.value === currentModel}
                borderRadius={8}
                isShowInBorder={true}
                className={styles.hover_board}
            >
                <div className={styles.preset_item_box} onClick={handleClick}>
                    <FJImage
                        imgSrc={item.imageUrl}
                        boxClassName={classNames(styles.img_box, !item.videoUrl ? styles.noVideo : '')}
                        imgClassName={styles.big_img}
                        alt={item.name}
                    />

                    {item.videoUrl && (
                        <video
                            src={item.videoUrl}
                            ref={videoRef}
                            loop
                            autoPlay
                            loading='lazy'
                            preload='auto'
                            muted={!isPlayingVideo}
                        />
                    )}
                </div>
            </FJHoverBoardGradation>

            <div className={styles.model_item_info}>
                <div className={styles.model_item_name}>
                    <span>{FJLocalStore._(item.name)}</span>
                    {item.renderImageIcon ? (
                        <img
                            src={item.renderImageIcon}
                            className={styles.model_item_icon + ' ' + styles.model_item_icon_image}
                            data-value={item.value}
                        />
                    ) : (
                        <item.icon className={styles.model_item_icon} data-value={item.value} />
                    )}
                </div>
                <div className={styles.model_item_desc}>{FJLocalStore._(item.description)}</div>
            </div>
        </div>
    );
}

FJAIVideoModelPreviewItem.propTypes = {
    model: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        videoUrl: PropTypes.string,
    }).isRequired,
    currentModel: PropTypes.string.isRequired,
    onModelSelect: PropTypes.func,
};

export default FJAIVideoModelPreviewItem;
